import modalShiftViewUrl from './noShowUserRow.html';

class NoShowUserRowCtrl {
  constructor(LeaveService, $state) {
    'ngInject';

    Object.assign(this, { LeaveService, $state });
  }

  $onInit() {
    this.leaveStatus = null;
    this._fetchDetails();
  }

  showEmployee() {
    const { user } = this.noShow;
    if (!user.deleted) {
      this.$state.go('users.profile', { userId: user.id });
    }
  }
}

export default {
  templateUrl: modalShiftViewUrl,
  controller: NoShowUserRowCtrl,
  controllerAs: 'ctrl',
  bindings: {
    noShow: '<',
    type: '@',
  },
};
